import { Config } from '@adornis/config/config.js';

export const config = new Config('medizintest', {
  ACCENTCOLOR: { client: true, defaultVal: '', env: true, name: 'ACCENT_COLOR', required: false },
  TECHNICALSUPPORTMAIL: {
    client: true,
    defaultVal: 'service@famed-test.de',
    env: true,
    name: 'TECHNICAL_SUPPORT_MAIL',
    required: false,
  },
  ACCOUNTINGMAIL: {
    client: true,
    defaultVal: 'rechnung@digifort-exports.de',
    env: true,
    name: 'ACCOUNTING_MAIL',
    required: false,
  },
  SERVICE_EMAIL: {
    client: false,
    defaultVal: 'service@famed-test.de',
    env: true,
    name: 'SERVICE_EMAIL',
    required: false,
  },
  TECHNICALSUPPORTPHONE: {
    client: true,
    defaultVal: '+49 561 827 914 49',
    env: true,
    name: 'TECHNICAL_SUPPORT_PHONE',
    required: false,
  },
  SMTP_SECURE: {
    client: false,
    env: true,
    name: 'SMTP_SECURE',
    required: false,
    defaultVal: false,
    parse(value) {
      return value === '1' || value === 'true';
    },
  },
  ROOT_URL: {
    client: true,
    env: true,
    name: 'ROOT_URL',
    required: false,
    defaultVal: '',
  },
  OPENAI_API_KEY: {
    client: false,
    env: true,
    name: 'OPENAI_API_KEY',
    required: false,
    defaultVal: '',
  },
  GEMINI_API_KEY: {
    client: false,
    env: true,
    name: 'GEMINI_API_KEY',
    required: false,
    defaultVal: '',
  },
});
